export const TAX_REGISTER_PERIOD = {
    FIRST: 1,
    SECOND: 2,
    THIRD: 3
};

const FIRST_PERIOD_LAST_DAY = 10;
const SECOND_PERIOD_LAST_DAY = 20;

/**
 * Buckets a tax register execution date into one of the three periods
 * a month is split into (1-10, 11-20, 21-end).
 * @param {string | Date} date Execution date of the tax register file.
 * @returns {number} One of TAX_REGISTER_PERIOD.FIRST/SECOND/THIRD.
 */
export const getTaxRegisterPeriod = (date) => {
    const day = new Date(date).getUTCDate();
    if (day <= FIRST_PERIOD_LAST_DAY) return TAX_REGISTER_PERIOD.FIRST;
    if (day <= SECOND_PERIOD_LAST_DAY) return TAX_REGISTER_PERIOD.SECOND;
    return TAX_REGISTER_PERIOD.THIRD;
};
